import * as React from "react";
const CloudRequest = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M7.001 6.504H16.754C18.861 6.504 19.914 6.504 20.671 7.011C20.999 7.23 21.281 7.511 21.499 7.839C22.005 8.597 22 9.902 22 12.011M12.003 6.504L11.369 5.236C10.844 4.186 10.364 3.128 9.201 2.691C8.691 2.5 8.11 2.5 6.946 2.5C5.129 2.5 4.22 2.5 3.538 2.88C3.05181 3.15168 2.65084 3.55334 2.38 4.04C2 4.722 2 5.63 2 7.45V10.509C2 15.229 2 17.588 3.465 19.054C4.579 20.169 6.21 20.436 9.002 20.5M12 18.833C12 20.306 13.12 21.5 14.5 21.5H19.75C20.993 21.5 22 20.425 22 19.1C22 17.658 20.82 16.694 19.739 16.7C19.877 15.06 18.644 13.5 17 13.5C15.562 13.5 14.381 14.678 14.26 16.179C12.992 16.308 12 17.447 12 18.833Z"
      stroke="#414651"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CloudRequest;
